import {styled} from "@mui/material/styles";
import {Grid, Typography} from "@mui/material";

export const PaymentHeading = styled(Typography)(() => ({
  fontSize: '1.71em',
  fontWeight: '500',
  lineHeight: '2.28em',
  fontFamily: 'Inter',
  color: 'rgba(0, 0, 0, 0.87)',
}));

export const PaymentTitle = styled(Typography)(() => ({
  fontSize: '1.14em',
  fontWeight: '500',
  lineHeight: '1.71em',
  fontFamily: 'Inter',
  color: 'rgba(0, 0, 0, 0.87)',
  letterSpacing: '0.03em',
}));

export const BookDetailsRow = styled(Grid)(() => ({
  borderBottom: '1px solid rgba(238, 238, 238, 1)',
  marginTop: '1.5em',
  paddingBottom: '0.5em !important',
}));

export const TransactionLabel = styled(Typography)(({theme}) => ({
  fontSize: '1.14em',
  fontWeight: '500',
  lineHeight: '1.71em',
  fontFamily: 'Inter',
  color: theme.palette.primary.main,
  cursor: 'pointer',
}))
